
  import { Component, Watch } from 'vue-property-decorator'
  import GTextarea from '@/components/core/input/GTextarea.vue'
  import PTitle from '@/components/config/PTitle.vue'
  import { GenioView } from './GenioView'
  import GCostField from '@/components/core/input/GCostField.vue'

@Component({
  components: { PTitle, GTextarea, GCostField },
})
  export default class ConfigPurchase extends GenioView {
    formData = {
      displayConsignment: false,
      consignmentPeriod: 0,
      withdrawalPeriod: 0,
      nonWithdrawalCost: 0,
      earlyWithdrawalPenalty: 0,
      directPurchase: false,
    }

    fieldsData = []

    async save () {
      if (!this.$refs.form.validate()) {
        await this.setFieldError()
        return
      }

      const fields = {
          id: this.process.id,
          config: {
            ...this.process.config,
            displayConsignment: this.formData.displayConsignment,
            directPurchase: this.formData.directPurchase,
          },
        }

      await this.updateProcess(fields)

      // Solo actualizar campos de consignación si está habilitada
      if (this.formData.displayConsignment) {
        await this.saveConsignmentFields()
      }

      this.$emit('update')
    }

  async saveConsignmentFields () {
    const fields = await this.fetchData({
          query: { name: 'find', model: 'Field' },
          filter: {
            document_type: {
              name: { _eq: 'consignment_contract' },
            },
          },
    })

    const consignmentPeriod = fields.find(field => field.name === 'consignment_period')
    consignmentPeriod.structure = { days: parseInt(this.formData.consignmentPeriod.toString()) }

    const withdrawalPeriod = fields.find(field => field.name === 'withdrawal_period')
    withdrawalPeriod.structure = { days: parseInt(this.formData.withdrawalPeriod.toString()) }

    const nonWithdrawalCost = fields.find(field => field.name === 'non_withdrawal_cost')
    nonWithdrawalCost.structure = { amount: parseInt(this.formData.nonWithdrawalCost.toString()) }

    const earlyWithdrawalPenalty = fields.find(field => field.name === 'early_withdrawal_penalty')
    earlyWithdrawalPenalty.structure = { amount: parseInt(this.formData.earlyWithdrawalPenalty.toString()) }

    const consignmentFields = [consignmentPeriod, withdrawalPeriod, nonWithdrawalCost, earlyWithdrawalPenalty]

      // Actualizar cada campo
    for (const fieldData of consignmentFields) {
      await this.pushData({
        model: 'Field',
        fields: {
          id: fieldData.id,
          structure: fieldData.structure,
        },
      })
    }
  }

    @Watch('process', { immediate: true, deep: true })
    async onConfigChange (newValue: any) {
      if (newValue?.config) {
        this.formData = {
          displayConsignment: newValue?.config?.displayConsignment,
          consignmentPeriod: 0,
          withdrawalPeriod: 0,
          nonWithdrawalCost: 0,
          earlyWithdrawalPenalty: 0,
          directPurchase: newValue?.config?.directPurchase,
        }

        const fields = await this.fetchData({
          query: { name: 'find', model: 'Field' },
          filter: {
            document_type: {
              name: { _eq: 'consignment_contract' },
            },
          },
        })

        this.fieldsData = fields

        const consignmentPeriod = fields.find(field => field.name === 'consignment_period')?.structure?.days
        const withdrawalPeriod = fields.find(field => field.name === 'withdrawal_period')?.structure?.days
        const nonWithdrawalCost = fields.find(field => field.name === 'non_withdrawal_cost')?.structure?.amount
        const earlyWithdrawalPenalty = fields.find(field => field.name === 'early_withdrawal_penalty')?.structure?.amount

        // Actualizar el formData con los valores obtenidos
        this.formData.consignmentPeriod = consignmentPeriod || 0
        this.formData.withdrawalPeriod = withdrawalPeriod || 0
        this.formData.nonWithdrawalCost = nonWithdrawalCost || 0
        this.formData.earlyWithdrawalPenalty = earlyWithdrawalPenalty || 0
      }
    }
  }
